"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockStore = void 0;
const store_1 = require("@completeanatomy/store");
const users_1 = require("./users");
const createMockStore = () => {
    const store = (0, store_1.createCAStore)();
    const reducer = (state = {}, action) => {
        if (action.type === 'currentUser') {
            return action.payload;
        }
        return state;
    };
    store.injectReducers({
        currentUser: reducer,
    });
    store.dispatch({
        type: 'currentUser',
        payload: users_1.testUser,
    });
    return store;
};
exports.createMockStore = createMockStore;
